import { render, staticRenderFns } from "./OrderServiceDeliveryQuotationInfo.vue?vue&type=template&id=392cc966&scoped=true&"
import script from "./OrderServiceDeliveryQuotationInfo.vue?vue&type=script&lang=js&"
export * from "./OrderServiceDeliveryQuotationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceDeliveryQuotationInfo.vue?vue&type=style&index=0&id=392cc966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cc966",
  null
  
)

export default component.exports